import React from "react";
import { dateToString, thousandFormatter } from "~/utils/formatter";
import { useTranslation } from "react-i18next";
import { INVEST_STEP } from "~/constant/ApplyFormConstant";

const MyInvestInfo = ({ portfolio }) => {
	const { t } = useTranslation();

	return (
		<li>
			<div className="title-group">
				<h3 className="basic-info-title">
					{t("pages.portfolio.PortfolioView.components.MyInvestInfo.history")}(
					{portfolio?.VcInvest?.length || 0})
				</h3>
				<span>
					{t("pages.portfolio.PortfolioView.components.MyInvestInfo.currentTotal")}:{" "}
					{thousandFormatter(portfolio.vcInvestTotal) || 0}
					{t("pages.portfolio.PortfolioView.components.MyInvestInfo.hMillion")}
				</span>
			</div>
			<div className="timeline-wrap">
				<ol>
					{portfolio?.VcInvest?.map((invest) => {
						return (
							<li key={invest.idx} className="timeline-item">
								<span className="timeline-date">
									{dateToString(invest.date, "yyyy-MM-dd")}
								</span>
								<ul className="timeline-content">
									<li>
										<ul className="vc-invest-history">
											<li>
												{t(
													"pages.portfolio.PortfolioView.components.MyInvestInfo.investStage"
												)}{" "}
												: <span>{INVEST_STEP[invest.step - 1]}</span>
											</li>
											<li>
												{t(
													"pages.portfolio.PortfolioView.components.MyInvestInfo.currentValue"
												)}{" "}
												:{" "}
												<span>
													{thousandFormatter(invest.comValue) || 0}
													{t(
														"pages.portfolio.PortfolioView.components.MyInvestInfo.hMillion"
													)}
												</span>
											</li>
											<li>
												{t(
													"pages.portfolio.PortfolioView.components.MyInvestInfo.investAmount"
												)}{" "}
												:{" "}
												<span>
													{thousandFormatter(invest.value) || 0}
													{t(
														"pages.portfolio.PortfolioView.components.MyInvestInfo.hMillion"
													)}
												</span>
											</li>
										</ul>
									</li>
								</ul>
							</li>
						);
					})}
				</ol>
			</div>
		</li>
	);
};

export default MyInvestInfo;
